import React from 'react'

import FormPage from '../../components/FormPage/FormPage'

const FondIZHSPage = () => {
    return (
        <FormPage>
            Получить займ Фонд поддержки ИЖС
        </FormPage>
    )
}

export default FondIZHSPage